(() => {
  const SUBMISSION_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwYIJyROWbMYarD-bOem2TUHd_gjSZJC3Dk2dYDSX6O0D0nawvK_QSzgaZ_D7kwRdMOBA/exec';
  const form = document.querySelector('[data-survey-form]');
  if (!form) return;

  const steps = [...form.querySelectorAll('.question-step')];
  const progressFill = document.querySelector('.progress-fill');
  const progressText = document.querySelector('[data-progress-text]');
  const progressSection = document.querySelector('[data-progress-section]');
  const nextButton = document.querySelector('[data-next]');
  const backButton = document.querySelector('[data-back]');
  const successView = document.querySelector('.success-view');
  const duplicateView = document.querySelector('.duplicate-view');
  const submissionKey = `beyondcanva:survey-submitted:${form.dataset.surveyId}`;
  let current = 0;
  let isSubmitting = false;

  const answerLabels = {
    fit: {
      'very-sturdy': 'Very secure',
      neutral: 'Neutral',
      'falls-off': 'Falls off easily'
    },
    shipping: {
      'very-satisfied': 'Very satisfied',
      satisfied: 'Satisfied',
      neutral: 'Neutral',
      dissatisfied: 'Dissatisfied'
    },
    reasons: {
      styles: 'Styles or designs',
      alternative: 'Preferred another brand or alternative',
      price: 'Price or shipping costs',
      quality: 'Quality or durability'
    },
    improvements: {
      sizing: 'Sizing accuracy and fit',
      adhesion: 'Adhesion',
      durability: 'Durability',
      none: 'No improvements needed'
    }
  };

  const hasSubmitted = () => {
    try {
      return Boolean(window.localStorage.getItem(submissionKey));
    } catch {
      return false;
    }
  };

  const rememberSubmission = () => {
    try {
      window.localStorage.setItem(submissionKey, JSON.stringify({ submittedAt: new Date().toISOString() }));
    } catch {
      // The survey still completes if browser storage is unavailable.
    }
  };

  const showDuplicateView = () => {
    steps.forEach(step => step.classList.remove('is-active'));
    successView.classList.remove('is-active');
    document.querySelector('.form-actions').hidden = true;
    document.querySelector('.progress-wrap').hidden = true;
    duplicateView.classList.add('is-active');
  };

  const render = () => {
    steps.forEach((step, index) => step.classList.toggle('is-active', index === current));
    const percent = Math.round(((current + 1) / steps.length) * 100);
    progressFill.style.width = `${percent}%`;
    progressText.textContent = `${percent}%`;
    progressSection.textContent = `${String(current + 1).padStart(2, '0')} / ${String(steps.length).padStart(2, '0')}`;
    backButton.hidden = current === 0;
    nextButton.textContent = current === steps.length - 1 ? 'Submit' : 'Continue →';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const validateCurrent = () => {
    const step = steps[current];
    const error = step.querySelector('.error-message');
    const requiredGroup = step.dataset.required === 'true';

    const emailField = step.querySelector('[data-email-field]');
    if (emailField) {
      emailField.value = emailField.value.trim();
      if (!emailField.checkValidity()) {
        error.textContent = 'Please enter a valid email address.';
        emailField.focus();
        return false;
      }
      error.textContent = '';
      return true;
    }

    if (!requiredGroup) {
      error.textContent = '';
      return true;
    }

    const checked = step.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (!checked) {
      error.textContent = 'Please choose at least one answer.';
      return false;
    }

    const otherCheckbox = step.querySelector('input[value="other"]:checked');
    const otherField = step.querySelector('[data-other-field]');
    if (otherCheckbox && otherField && !otherField.value.trim()) {
      error.textContent = 'Please tell us a little more.';
      otherField.focus();
      return false;
    }

    error.textContent = '';
    return true;
  };

  const getPayload = () => {
    const data = new FormData(form);

    if (form.dataset.surveyId === 'post-purchase-v1') {
      return {
        formType: 'post-purchase-v1',
        email: String(data.get('email') || '').trim().toLowerCase(),
        stars: Number(data.get('rating')),
        sturdiness: answerLabels.fit[data.get('fit')] || data.get('fit') || '',
        packaging: answerLabels.shipping[data.get('shipping')] || data.get('shipping') || '',
        feedback: String(data.get('feedback') || '').trim()
      };
    }

    const reasons = data.getAll('reasons').map(value => {
      if (value === 'other') {
        return `Other: ${String(data.get('reason-other') || '').trim()}`;
      }
      return answerLabels.reasons[value] || value;
    });
    const improvements = data.getAll('improvements').map(value => answerLabels.improvements[value] || value);

    return {
      formType: 'win-back-v1',
      email: String(data.get('email') || '').trim().toLowerCase(),
      noBuyReason: reasons,
      improvements,
      feedback: String(data.get('feedback') || '').trim()
    };
  };

  const submitSurvey = async () => {
    const response = await fetch(SUBMISSION_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(getPayload()),
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`Submission failed with status ${response.status}`);
    }

    const result = await response.json();
    if (!result || result.status !== 'success') {
      throw new Error(result && result.message ? result.message : 'The response was not accepted.');
    }
  };

  nextButton.addEventListener('click', async () => {
    if (isSubmitting) return;
    if (!validateCurrent()) return;
    if (current < steps.length - 1) {
      current += 1;
      render();
      return;
    }

    const error = steps[current].querySelector('.error-message');
    const submissionStartedAt = Date.now();
    isSubmitting = true;
    form.setAttribute('aria-busy', 'true');
    nextButton.disabled = true;
    nextButton.classList.add('is-submitting');
    nextButton.innerHTML = '<span>Submitting…</span><small>Please wait 3 seconds.</small>';

    try {
      await submitSurvey();
      const remainingWait = 3000 - (Date.now() - submissionStartedAt);
      if (remainingWait > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingWait));
      }
      form.querySelectorAll('.question-step').forEach(step => step.classList.remove('is-active'));
      document.querySelector('.form-actions').hidden = true;
      document.querySelector('.progress-wrap').hidden = true;
      rememberSubmission();
      successView.classList.add('is-active');
      successView.focus();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (submissionError) {
      console.error('Survey submission failed:', submissionError);
      error.textContent = 'We couldn’t save your response. Please check your connection and try again.';
      nextButton.disabled = false;
      nextButton.classList.remove('is-submitting');
      nextButton.textContent = 'Submit';
    } finally {
      isSubmitting = false;
      form.removeAttribute('aria-busy');
    }
  });

  backButton.addEventListener('click', () => {
    if (current > 0) {
      current -= 1;
      render();
    }
  });

  form.addEventListener('change', event => {
    const step = event.target.closest('.question-step');
    if (step) step.querySelector('.error-message').textContent = '';

    if (event.target.matches('[data-exclusive]') && event.target.checked) {
      const group = form.querySelectorAll(`input[name="${event.target.name}"]`);
      group.forEach(input => { if (input !== event.target) input.checked = false; });
    } else if (event.target.type === 'checkbox' && event.target.checked) {
      const exclusive = form.querySelector(`input[name="${event.target.name}"][data-exclusive]`);
      if (exclusive) exclusive.checked = false;
    }
  });

  form.querySelectorAll('textarea[maxlength]').forEach(textarea => {
    const counter = textarea.parentElement.querySelector('[data-char-count]');
    textarea.addEventListener('input', () => { counter.textContent = `${textarea.value.length} / ${textarea.maxLength}`; });
  });

  document.querySelectorAll('[data-copy-coupon]').forEach(copyButton => {
    copyButton.addEventListener('click', async event => {
      try {
        await navigator.clipboard.writeText('BCWJ10');
        event.currentTarget.textContent = 'Copied ✓';
      } catch {
        event.currentTarget.textContent = 'BCWJ10';
      }
    });
  });

  if (hasSubmitted()) {
    showDuplicateView();
  } else {
    render();
  }
})();
